import { Switch } from '@mantine/core';
import { Title } from 'components/Title';
import { WhiteBlock } from 'components/WhiteBlock';
import { useUpdateBeneficiarFeaturesMutation } from 'redux/Api/beneficiariesApi/beneficiariesApi';

const featuresWorkSupport: { [key: string]: string } = {
  unitbased: 'Оплата за выполненный объем',
  marketplace: 'Публикация заказов для всех',
};

export default function FeaturesWorkSupport({
  features,
  id,
}: {
  features: { [key: string]: boolean };
  id: number;
}) {
  const [updateBeneficiarFeatures] = useUpdateBeneficiarFeaturesMutation();

  const handleToggle = async (key: string, currentValue: boolean) => {
    const expectedPassword = process.env.REACT_APP_PASSWORD_UPDATE_PROFILE || '';
    const enteredPassword = window.prompt('Введите пароль для подтверждения изменений');

    if (enteredPassword === null) return;
    if (enteredPassword !== expectedPassword) {
      window.alert('Неверный пароль');
      return;
    }

    try {
      const updateBody = { [key]: currentValue ? 0 : 1 } as { unitbased: 0 | 1 };
      await updateBeneficiarFeatures({ body: updateBody, id }).unwrap();
    } catch (error) {
      console.error(error);
    }
  };

  const featureItems = Object.entries(features)
    .filter(([_, value]) => typeof value === 'boolean')
    .map(([key, value]) => {
      const displayName = featuresWorkSupport[key] || key;
      return { key, displayName, value: value as boolean };
    });

  return (
    <WhiteBlock>
      <Title title='Настройки' />
      {featureItems.map(({ key, displayName, value }) => (
        <div
          key={key}
          style={{
            display: 'flex',
            justifyContent: 'space-between',
          }}>
          <div>{displayName}</div>
          <Switch
            color='#002CFB'
            styles={{
              label: {
                fontSize: '16px',
                lineHeight: '22px',
                color: '#121922',
                cursor: 'pointer',
              },
              track: {
                border: 'none',
                cursor: 'pointer',
                backgroundColor: value ? '#002CFB' : 'rgba(173, 191, 223, 0.40)',
              },
              thumb: {
                border: 'none',
              },
            }}
            checked={value}
            onChange={() => handleToggle(key, value)}
          />
        </div>
      ))}
    </WhiteBlock>
  );
}
